
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M12 19H15.002V10.3939L12 13.4038V19ZM10 19V15.409L6.41846 19H10ZM20 19H17.002V8.38866L20 5.38273V19ZM20.255 2.29487C20.899 1.66497 22 2.11109 22 3.0019V20.0001C22 20.5523 21.5424 21 20.9778 21H4.02423C3.11356 21 2.6575 19.923 3.30144 19.2931L20.255 2.29487Z","fill":"#EE7F1A"}})])
          )
        }
      }
    